import { apiFetch } from "./client";
import { comprimiFoto } from "@/lib/comprimiFoto";
import type { ErroreRecente } from "./erroriRecenti";
import type { WizardPayload } from "@/chat/wizard/WizardConfig";

export interface ChatSession {
  session_id: string;
  cat_ws_url: string;
  is_new: boolean;
}

export function getChatSession(): Promise<ChatSession> {
  return apiFetch<ChatSession>("/chat/session");
}

export function getChatSessionCliente(): Promise<ChatSession> {
  return apiFetch<ChatSession>("/chat/session/cliente");
}

export async function uploadChatFile(
  file: File,
  kind: "bolletta" | "documento" = "bolletta",
  opzioni?: { analizza?: boolean },
): Promise<{ analisiId: string | null }> {
  const form = new FormData();
  // Foto più leggere prima di partire, come nel QR (lib/comprimiFoto): PDF e file che
  // il browser non sa decodificare (HEIC) partono come sono.
  form.append("file", await comprimiFoto(file));
  form.append("kind", kind);
  if (opzioni?.analizza) form.append("analizza", "true");
  const res = await fetch("/api/chat/upload", {
    method: "POST",
    credentials: "include",
    body: form,
  });
  // fetch non lancia sui 4xx/5xx: senza questo controllo un file respinto (502
  // cat_upload_failed, 9/9/2026) risultava caricato e nessuno lo veniva a sapere.
  if (!res.ok) {
    throw new Error(`upload_failed ${res.status} ${file.name}`);
  }
  try {
    const corpo = await res.json();
    return { analisiId: typeof corpo?.analisi_id === "string" ? corpo.analisi_id : null };
  } catch {
    return { analisiId: null };
  }
}

export interface ReportResponse {
  ok: boolean;
  segnalazione_id: string | null;
  attached: number;
}

export async function startChatFromWizard(payload: WizardPayload): Promise<ChatSession> {
  return apiFetch<ChatSession>("/chat/wizard-start", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export interface SegnalazioneProblema {
  nota: string;
  pagina: string;
  percorso: string;
  praticaId?: string;
  errori?: ErroreRecente[];
}

/** Segnalazione dal tasto in fondo al menù: stessa destinazione della
 *  bandierina della chat, ma porta il contesto della pagina. */
export async function segnalaProblema(s: SegnalazioneProblema): Promise<ReportResponse> {
  return apiFetch<ReportResponse>("/chat/report", {
    method: "POST",
    body: JSON.stringify({
      user_note: s.nota,
      pagina: s.pagina,
      percorso: s.percorso,
      pratica_id: s.praticaId,
      errori: s.errori ?? [],
    }),
  });
}

export async function reportBotMessage(
  messageContent: string,
  userNote?: string,
  messageTimestamp?: string,
): Promise<ReportResponse> {
  return apiFetch<ReportResponse>("/chat/report", {
    method: "POST",
    body: JSON.stringify({
      message_content: messageContent,
      user_note: userNote,
      message_timestamp: messageTimestamp,
    }),
  });
}
